import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import SignIn from "@/views/SignIn";
import SignUp from "@/views/SignUp";
import VerifyEmail from "@/views/VerifyEmail";
import Timer from "@/views/Timer";
import CheckIn from "@/views/CheckIn";
import Project from "@/views/Project";
import Feedback from "@/views/Feedback";

import store from "@/store";
Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/project/:projectId",
      name: "projectView",
      component: Project,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/project/:projectId/timer",
      name: "projectTimerView",
      component: Timer,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/project/:projectId/checkin",
      name: "projectCheckInView",
      component: CheckIn,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/signin",
      name: "signIn",
      component: SignIn
    },
    {
      path: "/signup",
      name: "signUp",
      component: SignUp
    },
    {
      path: "/verify-email",
      name: "verifyEmail",
      component: VerifyEmail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/feedback",
      name: "feedback",
      component: Feedback,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About/index.vue")
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  await store.getters.auth.initPromise;
  let currentUser = store.state.user;
  let requriesAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requriesAuth) {
    if (!currentUser) {
      next({ name: "about" });
    } else if (
      // Real and email not verified user can visit verify email page
      !currentUser.isAnonymous &&
      !currentUser.emailVerified &&
      to.name !== "verifyEmail"
    ) {
      next({ name: "verifyEmail" });
    } else if (
      // Anon user and email verified user can not visit verify email page
      (currentUser.isAnonymous || currentUser.emailVerified) &&
      to.name == "verifyEmail"
    ) {
      next({ name: "home" });
    } else {
      next();
    }
  } else {
    if (
      currentUser &&
      !currentUser.isAnonymous &&
      (to.name == "signIn" || to.name == "signUp")
    ) {
      next({ name: "home" });
    } else {
      next();
    }
  }
});
export default router;
